import { WorkspaceState } from './workspace';

export const dashboardWorkspace: WorkspaceState = {
  layout: [{ i: 'map', x: 0, y: 0, w: 12, h: 12 }],
  windows: [{ key: 'map', appName: 'Map' }],
};
